export const FETCH_TASK_RESULT_REQUEST = "FETCH_TASK_RESULT_REQUEST";
